module.exports = __webpack_public_path__ + "media/images/emblems/wappen_oberems-781059fe5c2b6d76a3d6bbd95ee1819a.png";